import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ServicoBio } from '../services/servico-bio.service';
import { AutorizacaoService } from '../../services/autorizacao.service';
import { NotificationService } from '@progress/kendo-angular-notification';

@Component({
  selector: 'app-bio-ofertas',
  templateUrl: './bio-ofertas.component.html',
  styleUrls: ['./bio-ofertas.component.scss']
})
export class BioOfertasComponent implements OnInit {

  produtosPromocionais: any[] = [];
  carregando = true;
  idBioPagina: number;
  slugBioPagina: string;
  exibirOfertas = true;
  modoPreview: 'mobile' | 'desktop' = 'mobile';
  urlPreview: SafeResourceUrl;
  timestampPreview = Date.now();

  constructor(
    private servicoBio: ServicoBio,
    private autorizacaoService: AutorizacaoService,
    private notificationService: NotificationService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.autorizacaoService.fetchUser().subscribe(usuario => {
      if (!usuario?.empresa?.id) {
        this.carregando = false;
        this.mostrarNotificacao('Nao foi possivel carregar os dados da empresa.', 'error');
        return;
      }

      this.servicoBio.obterBioPagina(usuario.empresa.id).then((data: any) => {
        if (data && data.id) {
          this.idBioPagina = data.id;
          this.slugBioPagina = data.slug;
          this.exibirOfertas = data.exibirOfertas !== false;
          this.atualizarUrlPreview();
          this.carregarProdutosPromocionais();
        } else {
          this.carregando = false;
        }
      }).catch(() => {
        this.carregando = false;
      });
    });
  }

  carregarProdutosPromocionais() {
    this.carregando = true;
    this.servicoBio.obterProdutosPromocionais().then((data: any[]) => {
      this.produtosPromocionais = data || [];
      this.carregando = false;
    }).catch(() => {
      this.carregando = false;
    });
  }

  atualizarUrlPreview() {
    if (!this.slugBioPagina) {
      this.urlPreview = null;
      return;
    }
    const url = window.location.origin + '/bio/' + this.slugBioPagina + '?preview=true&t=' + this.timestampPreview;
    this.urlPreview = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  recarregarPreview() {
    this.timestampPreview = Date.now();
    this.atualizarUrlPreview();
  }

  abrirEmNovaAba() {
    if (!this.slugBioPagina) return;
    window.open(window.location.origin + '/bio/' + this.slugBioPagina, '_blank');
  }

  toggleExibirOfertas() {
    this.exibirOfertas = !this.exibirOfertas;
    this.servicoBio.atualizarBioPagina(this.idBioPagina, { exibirOfertas: this.exibirOfertas } as any).then(() => {
      this.recarregarPreview();
      this.mostrarNotificacao(
        this.exibirOfertas ? 'Ofertas ativadas na pagina Bio!' : 'Ofertas desativadas na pagina Bio.',
        'success'
      );
    }).catch(() => {
      this.exibirOfertas = !this.exibirOfertas;
      this.mostrarNotificacao('Erro ao atualizar configuracao.', 'error');
    });
  }

  private mostrarNotificacao(mensagem: string, tipo: 'success' | 'error') {
    this.notificationService.show({
      content: mensagem,
      type: { style: tipo, icon: true },
      position: { horizontal: 'right', vertical: 'top' },
      hideAfter: 3000
    });
  }
}
